'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsGridComponent = exports.newsGridComponent = {
    template: require('./news-grid.html'),
    bindings: {
        newsitems: '<',
        errorOccurred: '<',
        viewMode: '@',
        badgeClicked: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: function newsOverviewController() {
        'ngInject';

        var vm = this;
        vm._badgeClicked = _badgeClicked;

        function _badgeClicked(categoryId) {
            vm.badgeClicked({ categoryId: categoryId });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-grid.js
// module id = 945
// module chunks = 0